// extracted by mini-css-extract-plugin
export default {"content":"ConfirmContractModal_content__0FgZ3"};